module.exports = __webpack_public_path__ + "static/media/ImpressumBackg.e9407dc2.png";